
<template>
    <div class="container">
        <!-- <div class="modal-overlay" v-if="!showPreview">
            <div class="modal-content">
            <div class="order-preview" v-if="!showPreview">
                <div class="preview-title">
                    <h3>הכל בסדר?</h3>
                    <p>נא לוודא שכל הפרטים הם נכונים לפני השליחה!</p>
                </div>
                <div class="preview-card">
                    <div class="card-header">
                        <button @click="showPreview = false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-chevron-right-icon lucide-circle-chevron-right"><circle cx="12" cy="12" r="10"/><path d="m10 8 4 4-4 4"/></svg>
                            חזרה לעריכה </button>
                        <span>#{{ counter.orderNumber }}</span>
                    </div>
                    <div class="card-body">
                        <div class="read-inputs">
                            <input type="text" v-model="fullname" disabled>
                            <input type="text" v-model="phoneNumber" disabled>
                        </div>
                        <div class="read-inputs">
                            <input type="text" v-model="selectedDateReadable" disabled>
                            <input type="text" v-model="timeOrder" disabled>
                        </div>
                    </div>
                    <div class="card-cart">
                        <span>פרטי הזמנה</span>
                        <div v-for="(product,index) in cart" :key="index" class="ProductLine">
                            <span class="selectedQuantity"> x{{ product.selectedCount }}</span>
                            
                            
                            <span class="name">{{ product.Data.Name }} </span>
                            <span class="price"> ₪{{ product.Data.Price * product.selectedCount}} </span>
                        
                        </div>
                        <div class="totalPrice">
                            <div class="discountLabel">
                                <label>הנחה \ שולם חלקי</label>
                                <input type="number" placeholder="הנחה" v-model.number="discount">
                            </div>

                            <span class="text">סה"כ לתשלום</span>
                            <span class="total"> ₪{{totalOrderPrice - discount}}</span>
                        </div>
                    </div>
                    
                </div>
                <div class="card-footer">
                        <div class="input-field">
                            <button @click="sendOrder()">אישור הזמנה </button>
                        </div>  
                    </div>
            </div>
        </div>
    </div> -->
    <div class="modal-overlay" v-if="showPreview" @click.self="showPreview = true">
  <div class="modal-content modern-modal">

    <!-- Header -->
    <div class="modal-header">
      <div>
        <h3>אישור הזמנה</h3>
        <p>נא לוודא שהפרטים נכונים</p>
      </div>
      <button class="close-btn" @click="showPreview = false">✕</button>
    </div>

    <!-- Order Info -->
    <div class="info-grid">
      <div class="info-box">
        <label>שם</label>
        <span>{{ fullname }}</span>
      </div>
      <div class="info-box">
        <label>מספר טלפון</label>
        <span>{{ phoneNumber }}</span>
      </div>
      <div class="info-box">
        <label>תאריך</label>
        <span>{{ selectedDateReadable }}</span>
      </div>
      <div class="info-box">
        <label>שעה</label>
        <span>{{ timeOrder }}</span>
      </div>
    </div>

    <!-- Cart -->
    <div class="cart-section">
      <div class="section-title">פרטי הזמנה</div>

      <div class="cart-list">
        <div 
          v-for="(product,index) in cart" 
          :key="index" 
          class="cart-item"
        >
          <div class="left">
            <span class="qty">x{{ product.selectedCount }}</span>
            <span class="name">{{ product.Data.Name }}</span>
          </div>

          <div class="price">
            ₪{{ product.Data.Price * product.selectedCount }}
          </div>
        </div>
      </div>

      <!-- Discount + Total -->
      <div class="summary">
        <div class="discount">
          <label>הנחה</label>
          <input type="number" v-model.number="discount" placeholder="0">
        </div>

        <div class="total">
          <span>סה"כ</span>
          <strong>₪{{ totalOrderPrice - discount }}</strong>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn-cancel" @click="showPreview = false">חזרה</button>
      <button class="btn-confirm" @click="sendOrder()">אישור הזמנה</button>
    </div>

  </div>
</div>
    <div class="newOrderSection">

    
    <div class="createOrder-template">
        <div class="page-header">
            <div class="head">
                <span class="page-title">יצירת הזמנה חדשה</span>
                <span class="counter-badge">#{{ counter.orderNumber }}</span>
            </div>
        </div>
        <div class="order-form">
            <div class="loader" v-if="loadingCounter">
                <div class="loader-item" ></div>
            </div>
            <div class="first-step">
                <!-- الرجوع للخلف -->
                <a href="#"v-if="!isFirstStep"@click.prevent="goToPrevious"> < חזרה </a>

                <div class="title">
                    {{ stepTitle }}
                </div>

                <div class="form-inputs" v-if="activeItemBar === 1">
                    <div class="input-field">
                        <label for="">שם לקוח</label>
                        <input type="text" placeholder="שם לקוח" v-model="fullname">
                    </div>
                    <div class="input-field">
                        <label for="">מספר טלפון</label>
                        <input type="number" placeholder="מספר טלפון" v-model="phoneNumber">
                    </div>
                    <div class="input-field">
                        <button @click="goToNext()">המשך </button>
                    </div>
                </div>

                <div class="form-inputs" v-if="activeItemBar === 2">
                    <div class="input-field">
                        <label for="">בחירת יום ותאריך</label>
                        <Calendar @date-selected="handleDateSelected" />
                    </div>
                    <div class="input-field">
                        <label for="">בחירת שעה</label>
                       <CalendarTime @time-selected="handleTimeSelect" />

                    </div>
                    <div class="input-field">
                        <button @click="goToNext()">המשך </button>
                    </div>
                </div>
                <div class="form-inputs" v-if="activeItemBar === 3">
                    <span>בחירת קטגוריה</span>
                    <div class="categories">
                        <div class="category" @click="loadProducts('עוגות מרובעות')">
                            <span class="category-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>
                            </span>
                            <span class="category-name">עוגות מרובעות</span>
                        </div>
                        <div class="category" @click="loadProducts('עוגות עגולות')">
                            <span class="category-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>
                            </span>
                            <span class="category-name">עוגות עגולות</span>
                        </div>
                        <!-- <div class="category" @click="loadProducts('עוגיות')">
                            <span class="category-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>
                            </span>
                            <span class="category-name">עוגיות</span>
                        </div> -->
                        <div class="category" @click="loadProducts('פסים')">
                            <span class="category-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>
                            </span>
                            <span class="category-name">פסים</span>
                        </div>
                        <div class="category" @click="loadProducts('קופסאות')">
                            <span class="category-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>
                            </span>
                            <span class="category-name">קופסאות</span>
                        </div>
                        <div class="category" @click="loadProducts('מגשים')">
                            <span class="category-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>
                            </span>
                            <span class="category-name">מגשים</span>
                        </div>
                        <div class="category" @click="loadProducts('שמרים')">
                            <span class="category-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>
                            </span>
                            <span class="category-name">שמרים</span>
                        </div>
                        <div class="category" @click="loadProducts('חד פעמי')">
                            <span class="category-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-archive-icon lucide-archive"><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></svg>
                            </span>
                            <span class="category-name">חד פעמי</span>
                        </div>
                    </div>


                    <span v-if="activeItemBar == 3 && activeProductsBar == 1">בחירת מוצרים</span>
                    <input v-model="txtSearch" type="text" placeholder="חיפוש מוצר" class="search-input-products" v-if="activeItemBar == 3 && activeProductsBar == 1">


                    <div class="products" v-if="activeItemBar == 3 && activeProductsBar == 1">
                        <div class="product" v-for="item in filteredProducts"  @click="addToCart(item)">
                            <img class="product-image" :src="item.Data.imageUrl" alt="" >
                            <span class="product-name">{{item.Data.Name}}</span>
                            <span class="product-price">₪{{item.Data.Price}}</span>
                        </div>
                    </div>
                    <div class="input-field">
                        <button @click="goToNext()">המשך </button>
                    </div>
                </div>
                <div class="form-inputs" v-if="activeItemBar === 4">
                                <div class="title">
                הוספת הערה להזמנה
            </div>
            <div class="paymentDiv">
                <div class="noteField">
                    <textarea  v-model="note" placeholder="הערה \ ملاحظة" > </textarea>
                    <!-- <i class="material-icons">payments</i>
                    <span class="paymentText">מזומן</span> -->
                </div>
            </div>

            <div class="title">
                סטטוס גבייה
            </div>
            <div class="paymentDiv">
                <div class="selectPayment">
                    <input type="radio" id="cash" value="שולם" v-model="paidStatus" required />
                    <i class="material-icons">price_check</i>
                    <span class="paymentText">שולם</span>
                </div>
                <div class="selectPayment">
                    <input type="radio" id="creditCard" value="לא שולם" v-model="paidStatus" required />
                    <i class="material-icons">money_off</i>
                    <span class="paymentText">לא שולם</span>
                </div>
            </div>

                    <div class="input-field">
                        <button @click="showPreview = true">אישור  </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="cart-btn" @click="openCartModal">
            <span class="badge">
                {{ cartItemCount  }}
            </span>
            <svg v-if="openCart" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-basket-icon lucide-shopping-basket"><path d="m15 11-1 9"/><path d="m19 11-4-7"/><path d="M2 11h20"/><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"/><path d="M4.5 15.5h15"/><path d="m5 11 4-7"/><path d="m9 11 1 9"/></svg>
        </div>
        <div class="modal-cart" v-if="openCart">
            <div v-if="this.cart.length <= 0" style="text-align: center;padding: 70px;"> 
                    אין מוצרים בסל הקניות
            </div>
            <div v-for="(product,index) in cart" :key="index" class="ProductLine">
                    <span class="selectedQuantity"> x{{ product.selectedCount }}</span>
                    
                    
                    <!-- <input type="number" v-model="product.selectedCount"> -->
                    <span class="name">{{ product.Data.Name }} </span>
                    <span class="price"> ₪{{ product.Data.Price * product.selectedCount}} </span>
                    <div class="tools">
                        <ul>
                            <li class="removeBtn" @click="removeItem(product,index)"><span class="material-icons">clear</span></li>
                            <li class="increaseBtn" @click="addToCart(product)"><span class="material-icons">add</span></li>
                            <li class="reduceBtn" @click="reduceItem(product,index)"><span class="material-icons">remove</span></li>
                        </ul>
                    </div>
                
                </div>
                <div class="totalPrice">
                    <div class="discountLabel">
                        <label>הנחה \ שולם חלקי</label>
                        <input type="number" placeholder="הנחה" v-model.number="discount">
                    </div>

                    <span class="text">סה"כ לתשלום</span>
                    <span class="total"> ₪{{totalOrderPrice - discount}}</span>
                </div>
            </div>
        </div>   
        <!-- <div class="desktop-cart">

        </div> -->
    </div>
        <div class="success-added" v-if="successAdded">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-package-check-icon lucide-package-check"><path d="m16 16 2 2 4-4"/><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"/><path d="m7.5 4.27 9 5.15"/><polyline points="3.29 7 12 12 20.71 7"/><line x1="12" x2="12" y1="22" y2="12"/></svg>
        <span>המוצר נוסף לסל</span>
        </div>
</div>
</template>

<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import he from 'moment/locale/he'
import order from '../components/Order.vue';
import Calendar from '../components/Calendar.vue';
import CalendarTime from '../components/CalendarTime.vue';

export default {
  name: 'newOrderbeta',
  components:{
    order, Calendar, CalendarTime
  },
  data () {
    return {
    orders:[],
    cart:[],
    Products:[],
    fullname:"",
    phoneNumber:"",
    timeOrder:"",
    dateOrder:moment().format("YYYY-MM-DD"),
    dayOrder:"",
    priceOrder:"",
    cakeTaste:"",
    cakeSize:"",
    workerName:"",
    counter:{
        orderNumber:0,
    },
    orderImg:[],
    status:"התקבלה",
    min:1000,
    activeProductsBar: 0,
    totalOrderPrice:0,
    selectedQuantity:1,
    productObj:"",
    note:"",
    paidStatus:"",
    discount:0,
    txtSearch:'',
    isLoading:false,
    firstStep : true,
    secStep : false,
    thirdStep : false,
    forthStep : false,
    selectedDateReadable: "",
    successAdded: false,
    activeItemBar: 1,
    loadingCounter: false,
      steps: [1, 2, 3, 4],
      openCart:false,
      showPreview:false,
}
  },
  created (){
    const m = moment();
    m.locale('he');
    let vm = this ;
    vm.loadOrders();
    vm.loadCounter();
    // vm.loadProductsToOrder();
  },
  computed: {
      filteredProducts() {
        let vm = this;
        if (vm.txtSearch.length > 0) {
          let Products = [];
          for (let i = 0; i < vm.Products.length; i++) {
            let t = vm.Products[i];
            let found = false;
            if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              found = true;
            }
            if (found) {
                Products.push(t);
            }
          }
          return Products;
        } else {
          return vm.Products;
        }
      },
       isFirstStep() {
      return this.activeItemBar === this.steps[0];
    },
    isLastStep() {
      return this.activeItemBar === this.steps[this.steps.length - 1];
    },
    stepTitle() {
    switch (this.activeItemBar) {
      case 1: return "פרטי לקוח";
      case 2: return "פרטי הזמנה";
      case 3: return "פרטי הזמנה";
      case 4: return "אישור";
      default: return "";
    }
    },
      cartItemCount() {
        return this.cart.reduce((total, item) => {
        return total + (item.selectedCount || 1); // إذا ما في selectedCount اعتبره 1
        }, 0);
     }

    },


  methods: {
     handleDateSelected(dateInfo) {
      this.dayOrder = dateInfo.key;
      this.selectedDateReadable = dateInfo.readable;
    },
      handleTimeSelect(time) {
    this.timeOrder = time;
    console.log("الوقت المختار:", time);
  },

        handleResize() {
      const heightDiff = this.originalHeight - window.innerHeight;
      this.isKeyboardOpen = heightDiff > 150;
    },
    handleFocus() {
      this.handleResize(); // فحص أولي
    },
    handleBlur() {
      this.isKeyboardOpen = false;
    },
    goNext() {
      alert("تم الانتقال ✅");
    },
    loadProducts(collectionName){

            let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', collectionName).orderBy("orderedTimes","desc").get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
    },
      extractISODate(str) {
        try {
            if (!str.includes('-')) return null;
            const parts = str.split('-');
            const rawDate = parts[1].trim(); // "2 ביולי 2025"
            const momentDate = moment(rawDate, 'D [ב]MMMM YYYY', 'he'); // لاحظ [ב] بدل ב لحرف ثابت
            return momentDate.isValid() ? momentDate.format('YYYY-MM-DD') : null;
        } catch (e) {
            console.error("❌ extractISODate error:", e);
            return null;
        }
    },

    sendOrder(){
    let vm = this;
    vm.isLoading = true;
    
    if (vm.fullname.length > 0 && vm.selectedDateReadable.length > 0 && vm.timeOrder.length > 0 &&  vm.paidStatus.length > 0  ){
    
    let extractedDate = this.extractISODate(vm.selectedDateReadable);
    console.log("📆 extracted:", extractedDate);

    let order = {
        fullname: vm.fullname,
        phoneNumber: vm.phoneNumber,
        orderImg: vm.orderImg,
        selectedDateReadable: vm.selectedDateReadable,
        timeOrder: vm.timeOrder,
        dayOrder: vm.extractISODate(vm.selectedDateReadable), // ✅ التاريخ بصيغة ISO
        totalOrderPrice: vm.totalOrderPrice,
        status: vm.status,
        createdDate: moment().format('LLLL'),
        orderNumber: vm.counter.orderNumber,
        cart: vm.cart,
        note : vm.note,
        paidStatus : vm.paidStatus,
        discount : vm.discount,
    }

      if(vm.phoneNumber.length == 10){
        db.collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").set(vm.counter).then((result) => {
        vm.loadCounter();
        console.log("Counter Updated");
    }).catch((error) => {
        console.log("Error");
    })
    db.collection("orders").add(order).then(function(orderResult){   
          vm.fullname="";
          vm.phoneNumber="";
          vm.timeOrder="";
          vm.dateOrder="";
          vm.dayOrder="";
          vm.priceOrder="";
          vm.orderImg=[];
          vm.cart=[];
          vm.status="התקבלה",
          vm.orderNumber="",
          vm.paidStatus="",
          vm.note = "" ,
          vm.discount = 0,
          vm.totalOrderPrice = 0
            console.log(orderResult);
        }).catch(function(error){
            console.error('add(order) Error !');
            console.error(error);
        });
        vm.isLoading = false;
        vm.activeItemBar = 1;
        vm.showPreview = false;
    }
    else{
        alert("מספר הטלפון חייב להכיל 10 ספרות בלבד")
    }

      }
   
    else if(vm.fullname.length <= 0 || vm.dayOrder.length <= 0 || vm.timeOrder.length <= 0 || vm.dateOrder.length <= 0 || vm.paidStatus.length <= 0 ) {
        alert("חובה למלא את כל השדות!");
    }   
        
      },
      uploadImage(e){
        
        if(e.target.files[0]){
                let file = e.target.files[0];
                let storageRef = firebase.storage().ref('orders/' + file.name);
                let uploadTask = storageRef.put(file);
                uploadTask.on('state_changed', 
                (snapshot) => { 
                }, 
                (error) => {
                    // Handle unsuccessful uploads
                }, 
                () => {
                    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    this.orderImg.push(downloadURL);
                    let media = { 
                        date: new Date().toLocaleDateString(),
                        image: "",
                        fullname: this.fullname,
                        orderNumber : this.counter.orderNumber
                    }
                    media.image = downloadURL;
                    db.collection("Media").add(media);
                    console.log('File available at', downloadURL);
                    });
                }
                );

            }

            
        },
        downloadFullExample() {
            const storageRef = firebase.storage().ref();

            // [START storage_download_full_example]
            // Create a reference to the file we want to download
            var starsRef = storageRef.child('orders/' + file.name);

            // Get the download URL
            starsRef.getDownloadURL()
            .then((url) => {
                // Insert url into an <img> tag to "download"
            })
            .catch((error) => {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                case 'storage/object-not-found':
                    // File doesn't exist
                    break;
                case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    break;
                case 'storage/canceled':
                    // User canceled the upload
                    break;

                // ...

                case 'storage/unknown':
                    // Unknown error occurred, inspect the server response
                    break;
                }
            });
            // [END storage_download_full_example]
        },
        loadOrders(){
          let vm = this;
          vm.orders = [];
          db.collection("orders").orderBy("createdDate","desc").get()
          .then(function(orderResult){
                  for(let a = 0; a < orderResult.size; a++){
                      let orderId = orderResult.docs[a].id;
                      let order = orderResult.docs[a].data();
                      vm.orders.push({ ID: orderId, Data: order });
              }
          })
          .catch(function(error){
              console.log("Error getting document:", error);
      });
      },
// loadCounter() {
//   let vm = this;
//   vm.loadingCounter = true ;
//   db.collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").get()
//     .then((doc) => {
//       if (doc.exists) {
//         vm.counter = doc.data();
//         if (vm.counter.orderNumber < vm.min) {
//           vm.counter.orderNumber = vm.min;
//         } else {
//           vm.counter.orderNumber++;
//         }
//         vm.loadingCounter = false ;
//       }
//     })
//     .catch((error) => {
//       console.error("❌ خطأ في تحميل العداد:", error);
//     });
// },
loadCounter(){
        let vm = this;
        vm.loadingCounter = true ;
        db.collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").onSnapshot((doc)=> {
            if (doc.exists){
                vm.counter = doc.data();
                vm.loadingCounter = false ;
                console.log("vm.orderNumber =" + JSON.stringify(vm.counter));
                if(vm.counter.orderNumber < vm.min){
                    vm.counter.orderNumber = vm.min;
                }
                else{
                    vm.counter.orderNumber++;
                }
            }
        })
      },

    addToCart(item) {
        this.txtSearch = '';
        let selectedCount = 1;
      const existingItem = this.cart.find(cartItem => cartItem.ID === item.ID);
        this.productObj = item;
        console.log(this.productObj);
      if (existingItem) {
        existingItem.selectedCount++;
        let newQuantity = item.Data.Quantity - existingItem.selectedCount;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
      } else {
        this.cart.push({ ...item, selectedCount: 1 });
        let newQuantity = item.Data.Quantity - 1;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
      }
      this.totalOrderPrice += item.Data.Price;
      console.log(this.cart);
      this.successAdded = true;
     setTimeout(() => {
      this.successAdded = false;
    }, 3000); // 3000 milliseconds = 3 seconds
    },
    reduceItem(item,index) {
      const existingItem = this.cart.find(cartItem => cartItem.ID === item.ID);
      let selectedCount = 1;
      if (existingItem) {
        existingItem.selectedCount--;
        let newQuantity = item.Data.Quantity - existingItem.selectedCount;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        if( existingItem.selectedCount == 0){
            
            let newQuantity = item.Data.Quantity ;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
            this.cart.splice(index, 1);
        }
      this.totalOrderPrice -= item.Data.Price;
      console.log(this.cart);
        }
        else{
            let newQuantity = item.Data.Quantity - existingItem.selectedCount + 1;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        }
    },
    removeItem(product,index) {
        let selectedCount = 1;
        if(product.selectedCount >= 1){
            let newQuantity = this.productObj.Data.Quantity ;
            console.log("Product Quantity :", product.Data.Quantity)
            console.log("Product Selected Quantity :", product.selectedCount)
            db.collection("Products").doc(product.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(product.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        }
      // Remove the item at the specified index from the array.
      this.cart.splice(index, 1);
      this.totalOrderPrice -= product.Data.Price * product.selectedCount;
    },
    openCartModal(){
        let vm = this;
        vm.openCart = !vm.openCart
    },
    goToNext() {
      if (!this.isLastStep) {
        this.activeItemBar++;
      }
    },
    goToPrevious() {
      if (!this.isFirstStep) {
        this.activeItemBar--;
      }
    },

      
    }
    }

</script>
<style scoped>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    
}
  .container{
        min-width: 100%;
        padding: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        flex-direction: column;
    }
    .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  width: 500px;
  max-width: 95%;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  max-height: 90vh;
  overflow-y: auto;
  animation: fadeIn 0.2s ease;
}
.modern-modal {
  border-radius: 16px;
  padding: 20px;
  font-family: 'Noto Sans Hebrew', sans-serif;
}

/* Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
}

.modal-header p {
  margin: 0;
  font-size: 13px;
  color: #777;
}

.close-btn {
  border: none;
  background: #f3f3f3;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 20px;
}

.info-box {
  background: #f9fafc;
  padding: 10px;
  border-radius: 10px;
}

.info-box label {
  font-size: 12px;
  color: #888;
}

.info-box span {
  display: block;
  font-weight: 600;
}

/* Cart */
.cart-section {
  margin-top: 10px;
}

.section-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.cart-list {
  max-height: 200px;
  overflow-y: auto;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-radius: 10px;
  background: #f7f7f7;
  margin-bottom: 6px;
}

.cart-item .left {
  display: flex;
  gap: 10px;
}

.qty {
  background: #004d5a;
  color: white;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
}

.name {
  font-weight: 500;
}

.price {
  font-weight: bold;
}

/* Summary */
.summary {
  margin-top: 15px;
}

.discount {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.discount input {
  width: 80px;
  padding: 5px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.total {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  
}

.total strong {
  color: #004d5a;
}

/* Footer */
.modal-footer {
  margin-top: 40px;
  display: flex;
  gap: 10px;
}

.btn-cancel {
  flex: 1;
  background: #eee;
  border: none;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
}

.btn-confirm {
  flex: 1;
  background: #004d5a;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
}
@keyframes fadeIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
    .newOrderSection{
    width: 70%;
    }
    .createOrder-template{
        width: 100%;
    }
    .page-header{
        width: 100%;
    }
        .head{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1rem 0;
    }
    .order-form{
        width: 100%;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        padding: 1rem;
        position: relative;
    }
    .order-form .loader{
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        min-width: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        min-height: 100%;
        z-index: 88;
        backdrop-filter: blur(2px);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .order-form .loader .loader-item{
        margin: auto;
        border: 5px solid #EAF0F6;
        border-radius: 67%;
        border-top: 5px solid rgb(1 67 66);
        width: 80px;
        height: 80px;
        -webkit-animation: spinner-data-v-2e949002 1s linear infinite;
        animation: spinner-data-v-2e949002 1s ease-in-out infinite;
        z-index: 100000;
    }
    @keyframes spinner {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    .first-step .title{
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 1rem;
    }
        .form-inputs{
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .form-inputs .input-field{
        width: 100%;
        border: 0;
    }
    .form-inputs .input-field label{
        font-size: 14px;
        color: #014342;
    }
    .form-inputs .input-field input{
        width: 100%;
        outline: none;
        background-color: transparent;
        padding: 5px 0;
        min-height: 45px;
        margin-bottom: 10px;
        border: 0;
        border-bottom: 1px solid #014342;
        font-size: 15px;
        color: #014342;
    }
.form-inputs .input-field button{
        background-color: #014342;
        color: #76E6B6;
        margin-top: 1rem;
        width: 100%;
        border: 0;
        min-height: 45px;
    }
    .categories, .products{
        display: flex;
        width: 100%;
        gap: 12px;
        overflow-x: auto;
        direction: rtl;
    }
    .search-input-products{
        padding: 5px 10px;
        border-radius: 5px;
        margin: 5px 0;
        font-size: 14px;
    }
    .categories .category,
    .products .product{
        min-width: 180px;
        color: #014342;
        background-color: #fff;
        border: 2px solid #014342;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin:1rem 0;
        padding: 0.5rem;
        position: relative;
    }
    .categories .category .category-icon{
        background-color: #014342;
        color: #76e6b6;
        padding: 5px;
        border-radius: 5px;
        margin-bottom: 1rem;
    }
    .categories .category .category-name{
        font-weight: 500;
        font-size: 14px;
    }
    .products .product .product-image{
        width: 100%;
        height: auto;
    }
    .products .product .product-name{
        display: block;
        font-size: 15px;
        font-weight: 600;
        text-align: center;
    }
    .products .product .product-price{
        margin-top: 0.5rem;
        font-weight: 700;
        font-size: 16px;
        color: #1b3f3e;  
    }
    .cart-btn{
        position: fixed;
        z-index: 9999;
        bottom: 87px;
        left: 1rem;
        background-color: #014342;
        color: #fff;
        padding: 16px;
        border-radius: 100%;
    }
    .cart-btn .badge{
        position: absolute;
        top: -15px;
        right: 0;
        background-color: #76E6B6;
        color: #014342;
        border-radius: 100%;
        padding: 8px 12px;
        font-size: 16px;
    }
    .modal-cart{
       position: fixed;
        width: 50%;
        background-color: #fff;
        border: 1px solid #014342;
        z-index: 99999;
        bottom: 175px;
        min-height: 65%;
        padding: 1rem;
        left: 1rem;
        border-radius: 20px;
    }
.productName{
    color: #000;
    font-size: 18px;
    font-weight: 600;
}
.productPrice{
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    font-size: 20px;
    font-weight: 600;
}
.productQuantity{
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    font-size: 18px;
    font-weight: 400;
    color:#666;
}
.ProductLine{
    padding: 1rem;
    font-size: 14px;
    font-weight: 500;
    color: #666;
    border-bottom: 1px solid #e0e0e0;
    position: relative;
}
.ProductLine .price{
    position: absolute;
    left: 1rem;
    color: #1c1c1c;
    font-weight: 700;
}
.discountLabel{
    width: 100%;
    margin-bottom: 1rem;
}
.discountLabel label{
    display: block;
    font-size: 13px;
}
.discountLabel input{
    width: 100%;
    padding: 0.5rem 1rem ;
    font-size: 13px;
    border-radius: 4px;
    border: #ddd 1px solid ;
}
.total{
    position: absolute;
    left: 1rem;
    color: #000;
}
.tools{
    width: 100%;
    min-height: 30px;
    background-color: transparent;
    margin-top: 10px;
    display: flex;
    align-items: center;
}
.tools ul{
    width: 100%;
}
.tools ul li{
    display: inline-block;
    padding: 0 20px;
    list-style: none;
}
.tools ul .removeBtn{
    float:right;
    background-color: #b91c1c;
    color:#fff;
    width:30px;
    height:30px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:2px;
    padding: 5px 0 ;
    cursor:pointer;
}
.tools ul .increaseBtn,
.tools ul .reduceBtn{
    float:left;
    background-color:aliceblue;
    color:#fff;
    font-size:22px;
    width: 30px;
    height: 30px;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-right:10px;
    border-radius:2px;
    padding: 5px 0 ;
    cursor:pointer;
}
.tools ul .removeBtn span{
    font-size:22px;
}
.tools ul .increaseBtn span,
.tools ul .reduceBtn span{
    font-size:22px;
    color:#000;
}
  .noteField{
    width: 100%;
  }
  .noteField textarea{
    width: 100%;
    min-height: 100px;
    max-height: 100px;
    padding: 0.5rem;
    border: 2px solid #FEBE10;
    border-radius: 8px;
    margin-top: 10px;
    background-color: #ffff;
    resize: none; 
  }
  .paymentStyle{
    width: 95%;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    min-height: 100px;
    overflow: hidden;
    padding: 1rem;
    margin-bottom: 10px;
  }
  .paymentStyle .title{
    width: 100%;
    display: block;
    font-family: 'Noto Sans Hebrew';
    font-weight: 700;
  }
  .paymentDiv{ 
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .selectPayment{
    padding: 1rem;
    border-radius: 4px;
    border: 1px solid #dfdfdf;
    background-color: #fcfcfc;
    min-height: 50px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .selectPayment input{
    width: 30px;
    height: 30px;
  }
  .selectPayment i{
    font-size: 35px;
    color: #014342;
    margin-right: 10px;
  }
  .selectPayment .paymentText{
    font-size: 22px;
    color: #014342;
    margin-right: 10px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
  }
  .success-added{
    position: absolute;
        bottom: 87px;
        background: #f8f9fa;
        padding: 0.5rem 1rem;
        border-radius: 5px;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12);
  }
 @media screen and (max-width:720px) {
    .container{
        min-width: 100%;
        padding: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        flex-direction: column;
    }
    .newOrderSection{
    width: 100%;
    }
    .createOrder-template{
        width: 100%;
    }
    .page-header{
        width: 100%;
    }
        .head{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1rem 0;
    }
    .order-form{
        width: 100%;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        padding: 1rem;
        position: relative;
    }
    .order-form .loader{
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        min-width: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        min-height: 100%;
        z-index: 88;
        backdrop-filter: blur(2px);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .order-form .loader .loader-item{
        margin: auto;
        border: 5px solid #EAF0F6;
        border-radius: 67%;
        border-top: 5px solid rgb(1 67 66);
        width: 80px;
        height: 80px;
        -webkit-animation: spinner-data-v-2e949002 1s linear infinite;
        animation: spinner-data-v-2e949002 1s ease-in-out infinite;
        z-index: 100000;
    }
    @keyframes spinner {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    .first-step .title{
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 1rem;
    }
        .form-inputs{
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .form-inputs .input-field{
        width: 100%;
        border: 0;
    }
    .form-inputs .input-field label{
        font-size: 14px;
        color: #014342;
    }
    .form-inputs .input-field input{
        width: 100%;
        outline: none;
        background-color: transparent;
        padding: 5px 0;
        min-height: 45px;
        margin-bottom: 10px;
        border: 0;
        border-bottom: 1px solid #014342;
        font-size: 15px;
        color: #014342;
    }
.form-inputs .input-field button{
        background-color: #014342;
        color: #76E6B6;
        margin-top: 1rem;
        width: 100%;
        border: 0;
        min-height: 45px;
    }
    .categories, .products{
        display: flex;
        width: 100%;
        gap: 12px;
        overflow-x: auto;
        direction: rtl;
    }
    .search-input-products{
        padding: 5px 10px;
        border-radius: 5px;
        margin: 5px 0;
        font-size: 14px;
    }
    .categories .category,
    .products .product{
        min-width: 180px;
        color: #014342;
        background-color: #fff;
        border: 2px solid #014342;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin:1rem 0;
        padding: 1rem 0.5rem;
        position: relative;
    }
    .categories .category .category-icon{
        background-color: #014342;
        color: #76e6b6;
        padding: 5px;
        border-radius: 5px;
        margin-bottom: 1rem;
    }
    .categories .category .category-name{
        font-weight: 500;
        font-size: 14px;
    }
    .products .product .product-name{
        display: block;
        font-size: 15px;
        font-weight: 600;
        text-align: center;
    }
    .products .product .product-price{
        margin-top: 0.5rem;
        font-weight: 700;
        font-size: 16px;
        color: #1b3f3e;  
    }
    .cart-btn{
        position: fixed;
        z-index: 9999;
        bottom: 87px;
        left: 1rem;
        background-color: #014342;
        color: #fff;
        padding: 16px;
        border-radius: 100%;
    }
    .cart-btn .badge{
        position: absolute;
        top: -15px;
        right: 0;
        background-color: #76E6B6;
        color: #014342;
        border-radius: 100%;
        padding: 8px 12px;
        font-size: 16px;
    }
    .modal-cart{
       position: fixed;
        width: 50%;
        background-color: #fff;
        border: 1px solid #014342;
        z-index: 99999;
        bottom: 175px;
        min-height: 65%;
        padding: 1rem;
        left: 1rem;
        border-radius: 20px;
    }
.productName{
    color: #000;
    font-size: 18px;
    font-weight: 600;
}
.productPrice{
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    font-size: 20px;
    font-weight: 600;
}
.productQuantity{
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    font-size: 18px;
    font-weight: 400;
    color:#666;
}
.ProductLine{
    padding: 1rem;
    font-size: 14px;
    font-weight: 500;
    color: #666;
    border-bottom: 1px solid #e0e0e0;
    position: relative;
}
.ProductLine .price{
    position: absolute;
    left: 1rem;
    color: #1c1c1c;
    font-weight: 700;
}
.discountLabel{
    width: 100%;
    margin-bottom: 1rem;
}
.discountLabel label{
    display: block;
    font-size: 13px;
}
.discountLabel input{
    width: 100%;
    padding: 0.5rem 1rem ;
    font-size: 13px;
    border-radius: 4px;
    border: #ddd 1px solid ;
}
.total{
    position: absolute;
    left: 1rem;
    color: #000;
}
.tools{
    width: 100%;
    min-height: 30px;
    background-color: transparent;
    margin-top: 10px;
    display: flex;
    align-items: center;
}
.tools ul{
    width: 100%;
}
.tools ul li{
    display: inline-block;
    padding: 0 20px;
    list-style: none;
}
.tools ul .removeBtn{
    float:right;
    background-color: #b91c1c;
    color:#fff;
    width:30px;
    height:30px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:2px;
    padding: 5px 0 ;
    cursor:pointer;
}
.tools ul .increaseBtn,
.tools ul .reduceBtn{
    float:left;
    background-color:aliceblue;
    color:#fff;
    font-size:22px;
    width: 30px;
    height: 30px;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-right:10px;
    border-radius:2px;
    padding: 5px 0 ;
    cursor:pointer;
}
.tools ul .removeBtn span{
    font-size:22px;
}
.tools ul .increaseBtn span,
.tools ul .reduceBtn span{
    font-size:22px;
    color:#000;
}
  .noteField{
    width: 100%;
  }
  .noteField textarea{
    width: 100%;
    min-height: 100px;
    max-height: 100px;
    padding: 0.5rem;
    border: 2px solid #FEBE10;
    border-radius: 8px;
    margin-top: 10px;
    background-color: #ffff;
    resize: none; 
  }
  .paymentStyle{
    width: 95%;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    min-height: 100px;
    overflow: hidden;
    padding: 1rem;
    margin-bottom: 10px;
  }
  .paymentStyle .title{
    width: 100%;
    display: block;
    font-family: 'Noto Sans Hebrew';
    font-weight: 700;
  }
  .paymentDiv{ 
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .selectPayment{
    padding: 1rem;
    border-radius: 4px;
    border: 1px solid #dfdfdf;
    background-color: #fcfcfc;
    min-height: 50px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .selectPayment input{
    width: 30px;
    height: 30px;
  }
  .selectPayment i{
    font-size: 35px;
    color: #014342;
    margin-right: 10px;
  }
  .selectPayment .paymentText{
    font-size: 22px;
    color: #014342;
    margin-right: 10px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
  }
  .success-added{
    position: absolute;
        bottom: 87px;
        background: #f8f9fa;
        padding: 0.5rem 1rem;
        border-radius: 5px;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12);
  }
 }   

  @media screen and (max-width:560px){
    .page-header{
        width: 100%;
        padding: 1rem;
        background-color: #014342;
    }
    .head{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
    .page-title{
        color: #fff;
    }
    .counter-badge{
        color: #014342;
        background-color:#76E6B6 ;
        padding: 3px 6px;
        border-radius: 8px;
    }
    .order-form{
        width: 100%;
        padding: 1rem;
        position: relative;
    }
    .order-form .loader{
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        min-width: 100%;
        background-color: rgba(0, 0, 0, .2);
        min-height: 100%;
    }
.newOrderSection{
    width: 100%;
    }
    .createOrder-template{
        width: 100%;
    }
    .first-step{
        background-color: #76e6b65e;
        border-radius: 10px;
        padding: 1rem;
    }
    .first-step .title{
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 1rem;
    }
    .form-inputs{
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .form-inputs .input-field{
        width: 100%;
        border: 0;
    }
    .form-inputs .input-field label{
        font-size: 14px;
        color: #014342;
    }
    .form-inputs .input-field input{
        width: 100%;
        outline: none;
        background-color: transparent;
        padding: 5px 0;
        min-height: 45px;
        margin-bottom: 10px;
        border: 0;
        border-bottom: 1px solid #014342;
        font-size: 15px;
        color: #014342;
    }
.form-inputs .input-field button{
        background-color: #014342;
        color: #76E6B6;
        margin-top: 1rem;
        width: 100%;
        border: 0;
        min-height: 45px;
    }
    .categories, .products{
        display: flex;
        width: 100%;
        gap: 12px;
        overflow-x: auto;
        direction: rtl;
    }
    .search-input-products{
        padding: 5px 10px;
        border-radius: 5px;
        margin: 5px 0;
        font-size: 14px;
    }
    .categories .category,
    .products .product{
        min-width: 130px;
        color: #014342;
        background-color: #fff;
        border: 2px solid #014342;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin:1rem 0;
        padding: 1rem 0.5rem;
        position: relative;
    }
    .categories .category .category-icon{
        background-color: #014342;
        color: #76e6b6;
        padding: 5px;
        border-radius: 5px;
        margin-bottom: 1rem;
    }
    .categories .category .category-name{
        font-weight: 500;
        font-size: 14px;
    }
    .products .product .product-name{
        display: block;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
    }
    .products .product .product-price{
        margin-top: 0.5rem;
        font-weight: 700;
        font-size: 16px;
        color: #014342;  
    }
    .cart-btn{
        position: fixed;
        z-index: 9999;
        bottom: 87px;
        left: 1rem;
        background-color: #014342;
        color: #fff;
        padding: 16px;
        border-radius: 100%;
    }
    .cart-btn .badge{
        position: absolute;
        top: -15px;
        right: 0;
        background-color: #76E6B6;
        color: #014342;
        border-radius: 100%;
        padding: 8px 12px;
        font-size: 16px;
    }
    .modal-cart{
        position: fixed;
        width: 100%;
        background-color: #fff;
        border: 1px solid #e0e0e0;
        z-index: 99999;
        bottom: 175px;
        min-height: 65%;
        padding: 1rem;
    }
.productName{
    color: #000;
    font-size: 18px;
    font-weight: 600;
}
.productPrice{
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    font-size: 20px;
    font-weight: 600;
}
.productQuantity{
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    font-size: 18px;
    font-weight: 400;
    color:#666;
}
.ProductLine{
    padding: 1rem;
    font-size: 14px;
    font-weight: 500;
    color: #666;
    border-bottom: 1px solid #e0e0e0;
    position: relative;
}
.ProductLine .price{
    position: absolute;
    left: 1rem;
    color: #1c1c1c;
    font-weight: 700;
}
.discountLabel{
    width: 100%;
    margin-bottom: 1rem;
}
.discountLabel label{
    display: block;
    font-size: 13px;
}
.discountLabel input{
    width: 100%;
    padding: 0.5rem 1rem ;
    font-size: 13px;
    border-radius: 4px;
    border: #ddd 1px solid ;
}
.total{
    position: absolute;
    left: 1rem;
    color: #000;
}
.tools{
    width: 100%;
    min-height: 30px;
    background-color: transparent;
    margin-top: 10px;
    display: flex;
    align-items: center;
}
.tools ul{
    width: 100%;
}
.tools ul li{
    display: inline-block;
    padding: 0 20px;
    list-style: none;
}
.tools ul .removeBtn{
    float:right;
    background-color: #b91c1c;
    color:#fff;
    width:30px;
    height:30px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:2px;
    padding: 5px 0 ;
    cursor:pointer;
}
.tools ul .increaseBtn,
.tools ul .reduceBtn{
    float:left;
    background-color:aliceblue;
    color:#fff;
    font-size:22px;
    width: 30px;
    height: 30px;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-right:10px;
    border-radius:2px;
    padding: 5px 0 ;
    cursor:pointer;
}
.tools ul .removeBtn span{
    font-size:22px;
}
.tools ul .increaseBtn span,
.tools ul .reduceBtn span{
    font-size:22px;
    color:#000;
}
  .noteField{
    width: 100%;
  }
  .noteField textarea{
    width: 100%;
    min-height: 100px;
    max-height: 100px;
    padding: 0.5rem;
    border: 2px solid #FEBE10;
    border-radius: 8px;
    margin-top: 10px;
    background-color: #ffff;
    resize: none; 
  }
  .paymentStyle{
    width: 95%;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    min-height: 100px;
    overflow: hidden;
    padding: 1rem;
    margin-bottom: 10px;
  }
  .paymentStyle .title{
    width: 100%;
    display: block;
    font-family: 'Noto Sans Hebrew';
    font-weight: 700;
  }
  .paymentDiv{ 
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .selectPayment{
    padding: 1rem;
    border-radius: 4px;
    border: 1px solid #dfdfdf;
    background-color: #fcfcfc;
    min-height: 50px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .selectPayment input{
    width: 30px;
    height: 30px;
  }
  .selectPayment i{
    font-size: 35px;
    color: #014342;
    margin-right: 10px;
  }
  .selectPayment .paymentText{
    font-size: 22px;
    color: #014342;
    margin-right: 10px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
  }
  .success-added{
position: absolute;
        bottom: 87px;
        background: #f8f9fa;
        padding: 0.5rem 1rem;
        border-radius: 5px;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12);    right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .success-added span{
    font-size: 13px;
    font-family: 'Noto Sans Hebrew';
  }



  }

@media screen and (max-width:360px){

}
</style>


// WEBPACK FOOTER //
// src/pages/newOrderbeta.vue